import * as React from 'react';
import { ITerm } from '../../state-helpers/facets';

interface IProps {
    term: ITerm,
    onTermClick: () => void;
}

export const MultiselectDropdownFacetTerm = ({ term, onTermClick }: IProps) => {
    return (
        <li>
            <div className="form-element-checkbox">
                <input type="checkbox"
                    readOnly={true}
                    className="form-element-checkbox"
                    id={term.id.toString()}
                    name={term.id.toString()}
                    value={term.id.toString()}
                    checked={term.selected}
                    onClick={onTermClick} /> 

                <label htmlFor={term.id.toString()}>
                    <svg className="selected">
                        <use xlinkHref="#checkbox-selected"></use>
                    </svg>
                    <svg className="unselected">
                        <use xlinkHref="#checkbox-unselected"></use>
                    </svg>
                </label>

                <div className="form-element-checkbox-text">
                    <p className="form-element-checkbox-text-term">{term.displayTerm}</p>
                    <p className="form-element-checkbox-text-number">
                        <span className="search-facet-item-number">({term.hits})</span>
                    </p>
                </div>
            </div>
        </li>
    );
}